import axios from 'axios';

export const customLogin = async (values) => {
  try {
    const body = {
      username: values.name,
      password: values.password
    };
    const { data } = await axios.post(`${window.BASE}${window.LOG_IN}`, body);

    localStorage.setItem('loginData', JSON.stringify(data));
    localStorage.setItem('usertype', data.userType);
    localStorage.setItem('token', data.token);

    if (data.userType === 'Admin') {
      localStorage.setItem('adminId', data.userId);
    } else {
      await getData(data.token, data.userId);
      localStorage.setItem('memberId', data.userId);
    
    }
    await  getConfig(data.token)
    return data;
  } catch (error) {}
};

const getData = async (tok, id) => {
  const h = {
    Authorization: `Bearer ${tok}`,
    'Content-Type': 'application/json'
  };
  try {
    const { data } = await axios.get(`${window.BASE}${window.MY_PROFILE}${id}`, { headers: h });
   
    localStorage.setItem('memberData', JSON.stringify(data));
  } catch (error) {}
};

const getConfig =async (tok)=>{
  const h = {
    Authorization: `Bearer ${tok}`,
    'Content-Type': 'application/json'
  };
  try {
    const { data } = await axios.get(`${window.BASE}${window.CONFIG}`, { headers: h });
   
    localStorage.setItem('config', JSON.stringify(data));
  } catch (error) {}
}
